import {RequestQuoteButton} from "../components/request-shipping-quote-button";
import {ExperimentalOrderMeta} from '@woocommerce/blocks-checkout';
import {DebugInfo} from "../components/debug";


export const Block = ({requestQuoteButtonLabel, quoteRequestedText, refreshLabel}) => {

	return <>
		<div className={'contact-for-shipping-quote'}>
			<RequestQuoteButton
				label={requestQuoteButtonLabel}
				quoteRequestedText={quoteRequestedText}
				refreshLabel={refreshLabel}
			>
			</RequestQuoteButton>
		</div>

		{/*Debug info*/}
		<ExperimentalOrderMeta>
			<DebugInfo/>
		</ExperimentalOrderMeta>
	</>
}
